import BtPopup from './BtPopup'

export { BtPopup }
export default BtPopup
